/**
 * MechaGuard - AchievementPanel (成就面板)
 *
 * 复用 .overlay / .overlay-content 的通用样式，未解锁的成就显示为
 * 灰色锁图标 + 提示文案，已解锁的高亮并显示图标。
 */

export class AchievementPanel {
  constructor() {
    this._root = null;
    this._els = {};
    this._handlers = {};
  }

  /**
   * @param {{onClose?:Function}} handlers
   */
  init(handlers = {}) {
    this._handlers = handlers;

    const root = document.getElementById('achievement-panel');
    if (!root) return;

    this._root = root;
    root.innerHTML = '';

    const box = document.createElement('div');
    box.className = 'overlay-content overlay-content--wide';

    const title = document.createElement('h2');
    title.className = 'overlay-title';
    title.textContent = '成就';

    const progress = document.createElement('p');
    progress.className = 'panel-progress';

    const grid = document.createElement('div');
    grid.className = 'ach-grid';

    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'btn btn-primary menu-btn';
    close.textContent = '关闭';
    close.addEventListener('click', () => this._handlers.onClose?.());

    box.append(title, progress, grid, close);
    root.appendChild(box);

    this._els = { progress, grid };
  }

  get isOpen() {
    return !!this._root && !this._root.classList.contains('hidden');
  }

  /**
   * @param {import('../systems/AchievementSystem.js').AchievementSystem} system
   */
  open(system) {
    if (!this._root || !system) return;

    this._render(system);
    this._root.classList.remove('hidden');
  }

  close() {
    if (this._root) this._root.classList.add('hidden');
  }

  /* ===================================================
   * 渲染
   * =================================================== */

  _render(system) {
    const list = system.list;
    const unlockedCount = system.unlockedCount;

    if (this._els.progress) {
      this._els.progress.textContent = `已解锁 ${unlockedCount} / ${list.length}`;
    }

    const grid = this._els.grid;
    if (!grid) return;

    grid.innerHTML = '';

    for (const achievement of list) {
      const card = document.createElement('div');
      card.className = achievement.unlocked ? 'ach-card unlocked' : 'ach-card';
      card.title = achievement.desc;

      const icon = document.createElement('span');
      icon.className = 'ach-icon';
      // 未解锁时不剧透图标，只给一个锁
      icon.textContent = achievement.unlocked ? achievement.icon : '🔒';

      const name = document.createElement('span');
      name.className = 'ach-name';
      name.textContent = achievement.name;

      const desc = document.createElement('span');
      desc.className = 'ach-desc';
      desc.textContent = achievement.desc;

      card.append(icon, name, desc);
      grid.appendChild(card);
    }
  }
}
